import styled from 'styled-components';

export const DraggableContainer = styled.div`
  transition: 150ms all ease-out;
  cursor: move;

  & > * {
    pointer-events: none;
  }
`;

export const DragImageContainer = styled.div`
  position: fixed;
  width: 64px;
  height: 64px;
  transition: 100ms scale;
  opacity: 0;
  z-index: 999;
  pointer-events: none;
`;
export const DragImage = styled.img`
  opacity: 1;
  object-fit: fill;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: white;
  outline: 1px solid white;
  box-shadow: ${({ theme: { shadows } }) => shadows.outerShadow};
`;
export const ValidityIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translate(-8px, 8px);
`;
